import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Solutionled(props) {
  return (
    <section className="solutionled p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Vision">
              <h2>Our Vision For Digital Solutions in Healthcare</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              Our digital health technology vision is based on the commitment to
              innovative healthcare delivery by leveraging the latest
              technology. We aim to provide accessibility, affordability, and
              equality for all with our digital solutions in healthcare.
            </p>
            <p>
              For that purpose, we have built some exceptional medical software
              solutions. We deploy suitable integrations that connect various
              software applications and systems, such as electronic health
              records (EHR), billing, and laboratory systems. Our goal for
              digital health innovation revolves around the following factors:
            </p>
            <div className="banner_content_txt listing_flex new-solutionlist">
              <ul>
                <li>Patient-centered Care</li>
                <li>Seamless Health Information Sharing</li>
                <li>Real-Time Insights</li>
                <li>Remote Monitoring</li>
                <li>Cybersecurity</li>
              </ul>
            </div>
            <div className="btn_talk sol-btn">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionled;
